<template lang="pug">
.layout_index
  .main(:class="{ 'close': isLeftClose }")
    .left
      .left-top
        img.left-close-userImg(src="../assets/userPic.png")
        .user_ctn
          img.left-top-bg(src="../assets/left-top-bg.png")
          img.logo(src="../assets/new_logo.png")
          .global_user
            img.fl.head_portrait(src="../assets/userPic.png")
            p.els.name(:title="(adUser.customerName && adUser.customerName.length > 7) ? adUser.customerName : ''") {{adUser.customerName || '请完成资质认证哦~'}}
            div
              span.role(v-if="customer.advertiserType === 2") 企业广告主
              span.role(v-else) 个人广告主
              span.phone {{adUser.userName}}

        .info
          .money.Akrobat-ExtraBold
            i ￥
            i(style="font-size:20px;") {{balance | fmtFee}}
              i .{{balance | fmtFee(1)}}
            span 账户余额
          .line
          .point.Akrobat-ExtraBold {{totalPutSn}}
            span 累计投屏

      .menu-btn(@click="closeLeft" :class="{'close': isLeftClose}")
        img.window_btn(src="../assets/window_size_btn.png")
      LeftNav(@clickMainMenu="navClick")
    .index-right
      //- .message-btn
      //-   .fl(@click="goMsg")
      //-     i.iconfont.icon-xiaoxi
      //-     span 消息
      //-     .red(v-if="hasNoReadMsg && hasNoReadMsg.length > 0")
      //-   .fr.line
      .log-out(@click="logOut")
        i.iconfont.icon-tuichu
        span 退出
      .top-tip(v-if="needGoAccount") 您的账户信息尚不完整，为保证广告的正常投放，请尽快补全。
        span(@click="goAccountPage") 点击前往 账号中心
      .index-top-tip(v-if="orderUploadTip" @click="goUrl('/orderVideo', {type: '0'})")
        div
          | 提醒：
          span
            | 您有
            span {{handleOrderNum}}
            | 个订单暂未发布，请及时上传
          i.el-icon-close(@click.stop="closeOrderNumTip")
      .index-top-tip(v-if="updateData")
        div
          | {{updateData}}
          i.el-icon-close(@click.stop="updateData = ''")
      keep-alive(:include="cacheWhite" :max="2")
        router-view.ctn
  GuideDialog
</template>

<script>
import { mapState } from 'vuex'
import LeftNav from '@/components/LeftNav'
import GuideDialog from '@/components/TheGuideDialog'
import { SpecialPageCode } from '@/utils/config'

export default {
    name: 'AdLayout',
    components: { LeftNav, GuideDialog },
    data(){
      return {
        cacheWhite: 'OrderList', // 需要进行缓存的页面组件白名单
        isLeftClose: false,
        orderUploadTip: false,
        handleOrderNum: 0,
        willUpdate: false,
        updateData: ''
      }
    },
    computed: {
      ...mapState({
        // hasNoReadMsg: s => {
        //   return s ? s.common.hasNoReadMsg : []
        // },
        balance: s => {
          return s ? s.customer.balanceInfo.balance : 0
        },
        totalPutSn: s => {
          return s ? s.common.totalPutSn : 0
        },
        customer: s => {
          return s ? s.customer.customerInfo : {}
        },
        adUser: s => {
          return s ? s.customer.userInfo : {}
        }
      }),
      needGoAccount () {
        if (this.adUser && this.adUser.id) { // 有用户信息
          return !this.adUser.customerId // 客户ID为0或不存在(即游客客户<=>只注册用户但未完善客户资料)
        }
        return false // 还未请求到用户信息
      },
      fee() {
        return (money, type) => {
          if(!money) return type ? '00' : 0
          let isMinus = money < 0
          if(isMinus) money = 0 - money
          if(!type) {
            let arr = (Math.floor(money)+'').split('').reverse()
            let a = []
            arr.forEach((el, i) => {
              a.push(el)
              if( (i+1)%3 == 0 ) a.push(',')
            })
            let str = a.reverse().join('')
            let data = str.charAt(0) == ',' ? str.slice(1): str
            return isMinus ? '-' + data : data
          } else {
            let sp = (money + '').split('.')
            return sp.length > 1 ? ( sp[1].length == 1 ? sp[1] + '0' : sp[1].substr(0, 2)) : '00'
          }
        }
      }
    },
    watch: {
      'adUser.customerId': {
        immediate: true,
        handler (cusId) {
          if (cusId && cusId > 0) { // 用户有绑定客户则获取关联的客户信息
            this.$store.dispatch('customer/getCustomerInfo', cusId)
          } else { // 未绑定或解绑原来关联的客户(解绑后客户id变为0,需重置store中客户数据)
            this.$store.commit('customer/setCusInfo', { pointRemainingNum: 0 })
            if (SpecialPageCode.indexOf(this.$route.name) > -1) {
              this.goUrl('/home')
            }
          }
        }
      },
      'customer.checkStatus': {
        handler (state) {
          // 用户所属客户状态非"生效中"且当前路由为4个投放页中的一个
          if (state !== 1 && SpecialPageCode.indexOf(this.$route.name) > -1) {
            this.goUrl('/home')
          }
        }
      }
    },
    beforeDestroy() {
      this.$root.$off('mapSearchListSpread')
    },
    async created() {
      await this.getUpdateInfo() // 系统升级状态
      const uid = localStorage.getItem('TzxUid')
      if (uid) await this.$store.dispatch('customer/getUserInfo', uid) // 用户信息

      // 处理 数据未请求完毕判断跳转页面闪现不允许出现的初始化页面 初始给透明度为0 隐藏显示
      document.querySelector('.layout_index').style.opacity = 1

      this.$store.dispatch('customer/getAccBalance') // 账户余额
      this.$store.dispatch('getMsgTipStatu') // 消息提示状态
      this.$store.dispatch('orderSum', { orderStatusList: '3,4' })
      this.getHandleOrder()
      this.getSearchEqual300() // 请求用户搜索点位时是否可以选小于300次

      this.$root.$on('mapSearchListSpread', () => {
        if (document.body.clientWidth <= 1310) this.isLeftClose = true
      })
    },
    mounted(){
      if (window.innerWidth <= 1280) this.isLeftClose = true
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          if(document.body.clientWidth < 1280) this.isLeftClose = true
          else this.isLeftClose = false
        })
      })
    },
    beforeRouteUpdate (to, from, next) {
      if ( document.body.clientWidth < 1280 && !this.isLeftClose ) this.isLeftClose = true
      next()
    },
    methods: {
      async getUpdateInfo () {
        let res = await this.fetch('/boss/upgradeTips/v2/info', {}, 'get')
        if (res) {
          if (res.code === 0) {
            if (res.data && res.data.status == 3) this.updateData = res.data.tips || ''
            else this.updateData = ''
            const s = setTimeout(() => {
              clearTimeout(s)
              if (this.$route.path === '/update') this.goUrl('/')
            }, 500)
          } else if (res.code == 900403) {
            this.goUrl('/update')
          }
        }
      },
      // 获取未发布(未上传素材)的订单数量
      async getHandleOrder () {
        if (localStorage.hasShowHandleOrder === '1') return
        let res = await this.fetch('/dsp/web/order/v2/countOrderNoContent', '', 'get')
        if(res && res.code == this.successCode) {
          this.handleOrderNum = res.data || 0
          if (res.data - 0 > 0) this.orderUploadTip = true
          else this.orderUploadTip = false
        }
      },
      async getSearchEqual300 () {
        let res = await this.fetch('/boss/common/config/v2/getPlayCountLimit', {}, 'get')
        if (res && res.code === 0) { // 用户自选次数
          this.$store.commit('setStoreData', { key: 'selfChoosePlayTimes', value: res.data || '' })
        }
      },
      goAccountPage () {
        if (this.$route.name === 'accountInfo') return
        this.goUrl('/accountInfo')
      },
      closeLeft () {
        this.isLeftClose = !this.isLeftClose
        this.$root.$emit('rootEmitCloseLeft')
      },
      goMsg () {
        if (this.$route.name === 'message') return
        tzx_czcPush('index', 'clickMsgBtn')
        this.goUrl('/message')
      },
      closeOrderNumTip () {
        this.orderUploadTip = !this.orderUploadTip
        localStorage.setItem('hasShowHandleOrder', 1)
      },
      navClick(item){
        if(this.isLeftClose && item.list && item.list.length > 0) this.isLeftClose = false
      }
    }
}
</script>

<style lang="sass">
.layout_index
  min-width: 980px
  opacity: 0
  .log-out
    cursor: pointer
    i
      font-size: 14px
      margin-right: 5px
  .left-close-userImg
    display: none
    width: 30px
    height: 30px
    margin-top: 70px

  .user_ctn
    padding: 15px 20px
    position: relative

.message-btn, .log-out
  z-index: 999

.layout_index > .main.close
  padding-left: 70px
  >.left
    left: 0
    box-shadow: 0 11px 70px 0 rgba(0,0,0,0.1)
    width: 50px
    text-align: center
    .left-top
      height: 120px
      >div
        display: none
  .left-close-userImg
    display: inline-block
  .window_btn
    margin-right: -5px
    transform: rotateY(180deg)
  .left-top
    border-radius: 0 !important
    margin-bottom: 20px !important
  .menu_list
    padding: 10px 0
    .fl.img
      margin: 15px
    .main_menu span, .main_menu .fr
      display: none
    .list
      display: none
      position: absolute
      left: 60px
      top: -1px
      width: 220px
      height: auto
      padding: 10px 0
      background-color: #FFFFFF
      border-radius: 4px
      border: 1px solid #fff
      overflow: initial
      opacity: 1
      box-shadow: 0 11px 70px 0 rgba(#000, .1)
      &::after
        position: absolute
        left: -11px
        top: -1px
        content: ''
        display: block
        width: 12px
        height: 48px
        border-top: 1px solid rgba(40, 39, 41, 1)
        border-bottom: 1px solid rgba(40, 39, 41, 1)
        background-color: rgba(245, 245, 245, 1)
        opacity: 0
    .each:hover
      background-color: rgba(245, 245, 245, 1)
      border-top: 1px solid rgba(245, 245, 245, 1)
      border-bottom: 1px solid rgba(245, 245, 245, 1)
      .main_menu
        height: 48px !important
        .img
          margin: 14px 15px !important
      >.list
        display: block !important

/* 1280px < 屏幕宽度 < 1460px */
@media screen and (max-width: 1460px)
  .layout_index > .main
    padding-left: 280px
    .left
      width: 260px
      left: 0

/* 屏幕宽度 < 1280px 默认样式收起 */
@media screen and (max-width: 1280px)
  .layout_index > .main
    padding-left: 70px
    .left
      width: 260px
      left: 0
      box-shadow: 0 11px 70px 0 rgba(0,0,0,0.1)
</style>
